// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__1agVk","icon":"style_icon__2iYrs","title":"style_title__4zZgB","logo":"style_logo__1DMyg","logoContainer":"style_logoContainer__1GBmE"};